<template>
	<div>
		<el-form :inline="true">
			<el-form-item label="门店名：" label-width="100">
				<el-input v-model="searchForm.name" placeholder="门店名" clearable></el-input>
			</el-form-item>
			<el-form-item label="门店名：" label-width="100">
				<el-input v-model="searchForm.realName" placeholder="姓名" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="getCommunity" type="success">搜索</el-button>
			</el-form-item>

			<!-- <el-form-item>
				<el-button type="primary" @click="update(null)">
					添加门店
				</el-button>
			</el-form-item> -->
		</el-form>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe>
			<el-table-column label="店号" align="center" prop="shopNumber"></el-table-column>
			<el-table-column label="门店" align="center" prop="name"></el-table-column>
			<el-table-column label="地址" align="center" prop="address">
			</el-table-column>
			<el-table-column label="姓名" align="center" prop="userName">
			</el-table-column>
			<el-table-column label="联系方式" align="center" prop="phone"></el-table-column>
			<!-- <el-table-column label="营业时间" align="center" prop="businessTime">
			</el-table-column> -->
			<!-- <el-table-column label="简介" align="center" prop="introduction"></el-table-column> -->
			<el-table-column prop="icon" align="center" width="360" fixed="right" label="操作">
				<template slot-scope="scope">
					<el-button type="primary" plain @click="update(scope.row.id)">
						编辑
					</el-button>
					<!-- <template>
						<el-popconfirm title="确定删除该门店吗？" @confirm="delHandle(scope.row.id)">
							<el-button type="danger" plain slot="reference">删除</el-button>
						</el-popconfirm>
					</template> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total"></el-pagination>
		<updata ref="updata" v-if="updata" @refreshDataList="getCommunity" />

	</div>
</template>

<script>
import updata from './updata'

export default {
	name: 'park',
	components: {
		updata
	},
	data() {
		return {
			searchForm: {
				name: '',
			},
			dialogVisible: false,
			editForm: {
				type: 1,
				content: ''
			},

			tableData: [],
			total: 0,
			size: 10,
			current: 1,
			updata: false,
			gardenWorker: false,
			gardenGoods: false,
		}
	},
	created() {
		this.getCommunity()
	},
	methods: {


		update(id) {
			this.updata = true
			this.$nextTick(() => {
				this.$refs.updata.init(id)
			})
		},
		gardenWorkerList(id) {
			this.gardenWorker = true
			this.$nextTick(() => {
				this.$refs.gardenWorker.init(id)
			})
		},
		gardenGoodsList(id) {
			this.gardenGoods = true
			this.$nextTick(() => {
				this.$refs.gardenGoods.init(id)
			})
		},
		handleSizeChange(val) {
			this.size = val
			this.getCommunity()
		},
		handleCurrentChange(val) {
			this.current = val
			this.getCommunity()
		},
		//获取列表
		getCommunity() {
			let that = this
			this.searchForm.pageNo = this.current
			this.searchForm.pageSize = this.size
			this.$axios
				.post('/admin/store/getStoreList', this.searchForm)
				.then((res) => {
					this.tableData = res.data.records
					this.total = res.data.total
					this.current = res.data.current
					this.size = res.data.size
				})
		},
		//删除
		delHandle(id) {
			this.$axios
				.post('/admin/store/deleteStore', {
					id: id
				})
				.then((res) => {
					this.$message({
						showClose: true,
						message: '恭喜你，删除成功',
						type: 'success',
						onClose: () => {
							this.getCommunity()
						},
					})
				})
		},
	},
}
</script>

<style scoped>
.el-button {
	padding: 0 10px;
	height: 35px;
	line-height: 35px;
	font-size: 15px;
	margin-right: 10px;
}
</style>